import StandaloneArticleTeaser from 'base/components/ArticleTeaser/Default';

export type TitlePosition = 'standard' | 'titleRightSideOfImage' | 'titleLeftSideOfImage';

export default StandaloneArticleTeaser;
